import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { AuthContextProvider } from '../src/context/auth-context';
import LoaderContextProvider from 'components/shared/Loader/LoaderContext';

ReactDOM.render(
    <React.StrictMode>
        <LoaderContextProvider>
            <AuthContextProvider>
                <App />
            </AuthContextProvider>
        </LoaderContextProvider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
